import React from 'react'

import AuthorizedLink from './AuthorizedLink'

const HomeSideNav = ({ currentUser, serverProperties, trainingUrl }) => {

  const auths = currentUser.authorizations ? currentUser.authorizations : []
  const affs = currentUser.affiliations ? currentUser.affiliations : []
  const url = trainingUrl.value ? trainingUrl.value.replace('&equals;', '=') : [];
  const canAccessAnyApp = auths.includes('APPLICATION_Application-User Management')
    || auths.includes('APPLICATION_LGY Enterprise Administration')
    || auths.includes('APPLICATION_SIM')
    || auths.includes('APPLICATION_SAH')
    || auths.includes('APPLICATION_LGY Suite')
    || auths.includes('APPLICATION_NADL')
    || auths.includes('APPLICATION_FFPS')
    || (currentUser.id)

  /* TODO: Need some discussion about how to handle this - don't prefer to have "negative" functions. See further logic, this is really just a check for whether user is a VA Employee. 
   Should probably create VA Employee role with View Reports functionality, but we start to run into the boundary between entities and functionalities. Could also program entities to generate authorities in the response to check. */
  const isNCCorVSO = auths.includes('ROLE_View Loan Guaranty Reports') || auths.includes('ROLE_National Call Center')

  return (
    canAccessAnyApp &&
    <ul id='home-side-nav' className='home-side-nav usa-sidenav-list'>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_Application-User Management')} href='/lgyhub/AccessManager/'>Access Manager</AuthorizedLink>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_LGY Enterprise Administration')} href='/lgyhub/LgyAdmin/'>LGY Admin</AuthorizedLink>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_SIM')} href='/lgyhub/SIM/'>SIM</AuthorizedLink>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_SAH')} href='/lgyhub/SAH/'>SAH</AuthorizedLink>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_LGY Suite')} href='/lgyhub/WebLGY/UserLogin.do'>WebLGY</AuthorizedLink>
      <AuthorizedLink external authorization={currentUser.id} href={serverProperties?.sarTpssUrl}>LAPP SAR Training</AuthorizedLink>
      <AuthorizedLink external authorization={affs.some(a => a.name === 'LENDER' || a.lappSar)} href={serverProperties?.creditStandardsUrl}>Credit Standards Course</AuthorizedLink>
      <AuthorizedLink external authorization={currentUser.id && !currentUser.isAffiliate && !isNCCorVSO} href={serverProperties?.lgyReportsUrl}>Loan Guaranty Reports</AuthorizedLink>
      <AuthorizedLink authorization={auths.includes('APPLICATION_NADL')} href='/lgyhub/NADL/'>NADL</AuthorizedLink>
      <AuthorizedLink external authorization={currentUser.id} href={serverProperties?.signUpCommucationsUrl}>Sign up for LGY Communications</AuthorizedLink>
      <AuthorizedLink external authorization={currentUser.id && !currentUser.isAffiliate} href={url}>Training Request</AuthorizedLink>
      <AuthorizedLink external authorization={auths.includes('APPLICATION_FFPS')} href='/lgyhub/ffps/'>FFPS</AuthorizedLink>
    </ul>
  )
}

export default HomeSideNav
